__webpack_require__.p = "https://s3.eu-west-2.amazonaws.com/polygonjs-assets/1_2_83__editor__1_2_83-1_/";